module.exports = {
  cloudinary: {
    url: 'https://images.spot.im/image/upload'
  },
  template: {
    interpolate: /<#=([\s\S]+?)#>/g,
    evaluate: /<#([\s\S]+?)#>/g
  },
  zeroclipboard: '/assets/ZeroClipboard.swf',
  zendeskWidgetKey: '21e02e5a-b884-4ddf-83d7-a46358e4f58f',
  sentry: {
    dsn: 'https://89ad62669cde4be58d07a632fe5143f7@o294277.ingest.sentry.io/1540928'
  }
};
